<template>
  <div class="sueldos-home">
    <div class="header">
      <h1>Gestión de Sueldos</h1>
    </div>

    <div class="tabs-container">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        :class="['tab-btn', { active: activeTab === tab.id }]"
        @click="activeTab = tab.id"
      >
        {{ tab.label }}
      </button>
    </div>

    <div class="tab-content">
      <LiquidacionesHome v-if="activeTab === 'liquidaciones'" />
      <CondicionesLaboralesHome v-if="activeTab === 'condiciones'" />
      <RegistroHorasHome v-if="activeTab === 'horas'" />
    </div>
  </div>
</template>

<script>
import LiquidacionesHome from '@/components/shared/sueldos/LiquidacionesHome.vue';
import CondicionesLaboralesHome from '@/components/shared/sueldos/CondicionesLaboralesHome.vue';
import RegistroHorasHome from '@/components/shared/sueldos/RegistroHorasHome.vue';

export default {
  name: 'SueldosEmpresaHome',
  components: {
    LiquidacionesHome,
    CondicionesLaboralesHome,
    RegistroHorasHome,
  },
  data() {
    return {
      activeTab: 'liquidaciones',
      tabs: [
        { id: 'liquidaciones', label: 'Liquidaciones' },
        { id: 'condiciones', label: 'Condiciones Laborales' },
        { id: 'horas', label: 'Registro de Horas' },
      ],
    };
  },
};
</script>

<style scoped>
.sueldos-home {
  padding: 1rem;
}

.header {
  margin-bottom: 1.5rem;
}

.header h1 {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.tabs-container {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
}

.tab-btn {
  padding: 0.75rem 1.5rem;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-size: 1rem;
  color: #666;
  transition: all 0.2s ease;
}

.tab-btn:hover {
  color: #333;
}

.tab-btn.active {
  border-bottom-color: #1976d2;
  color: #1976d2;
  font-weight: 500;
}

.tab-content {
  min-height: 400px;
}
</style>
